// @flow
import { useDispatch } from 'react-redux';

import {
  selectCartIsReopenable,
  selectCartGrid,
  resumeCart,
  removeCartProduct,
  getCart,
  selectDomainCreateProducts,
} from '@gandi/cart';
import type { ProductId } from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator, type TranslatorProps } from '@gandi/translate';

import type { Dispatch, GetState } from '../../../../../../types';
import { fetchDomainCreateProductsCatalog } from '../../../../../modules/actions';

const doRemoveProduct =
  (productId: ProductId, __: TranslatorProps['__']) =>
  async (dispatch: Dispatch, getState: GetState) => {
    const isCartIsReopenable = selectCartIsReopenable(getState());
    const gridBeforeDelete = selectCartGrid(getState());

    try {
      if (isCartIsReopenable) await dispatch(resumeCart());
    } catch (e) {} // eslint-disable-line no-empty

    try {
      await dispatch(removeCartProduct(productId));
    } catch (err) {
      notifyDanger(
        err._error || __('Unable to remove the product from the cart.'),
      );
    }
    try {
      await dispatch(getCart());
      const newGrid = selectCartGrid(getState());
      // update catalog if grid has changed
      if (gridBeforeDelete !== newGrid) {
        const domainProducts = selectDomainCreateProducts(getState());
        // $FlowFixMe[incompatible-call] bad typing between definition of products between the selector and the action
        await dispatch(fetchDomainCreateProductsCatalog(domainProducts));
      }
    } catch (e) {} // eslint-disable-line no-empty
  };

export function useRemoveProductHandler(
  productId?: ProductId,
): (evt: SyntheticEvent<HTMLButtonElement>) => Promise<void> {
  const { __ } = useTranslator();
  const dispatch = useDispatch();

  return async (evt: SyntheticEvent<HTMLButtonElement>) => {
    evt.preventDefault();

    if (!productId) return;

    dispatch(doRemoveProduct(productId, __));
  };
}
